/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BillingPlatform = {
    Basware: 'BASWARE',
    Cegedim: 'CEGEDIM',
    ChorusPro: 'CHORUS_PRO',
    Coupa: 'COUPA',
    CustomPersonalBillingPlatform: 'CUSTOM_PERSONAL_BILLING_PLATFORM',
    Docapost: 'DOCAPOST',
    Easy: 'EASY',
    Edokial: 'EDOKIAL',
    Hubwoo: 'HUBWOO',
    Ivalua: 'IVALUA',
    RandstadSourceright: 'RANDSTAD_SOURCERIGHT',
    SapAriba: 'SAP_ARIBA',
    Taulia: 'TAULIA',
    Tradeshift: 'TRADESHIFT',
    Tungsten: 'TUNGSTEN'
} as const;
export type BillingPlatform = typeof BillingPlatform[keyof typeof BillingPlatform];


export function instanceOfBillingPlatform(value: any): boolean {
    for (const key in BillingPlatform) {
        if (Object.prototype.hasOwnProperty.call(BillingPlatform, key)) {
            // @ts-ignore
            if (BillingPlatform[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BillingPlatformFromJSON(json: any): BillingPlatform {
    return BillingPlatformFromJSONTyped(json, false);
}

export function BillingPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingPlatform {
    return json as BillingPlatform;
}

export function BillingPlatformToJSON(value?: BillingPlatform | null): any {
    return value as any;
}

